import { Routes } from '@angular/router';

import { LandingPageComponent } from './landing/landing-page';
import { RegisterFlowComponent } from './register/register-flow';
import { StatusCheckFlowComponent } from './status-check/status-check-flow';
import { DashboardMain } from './dashboard/dashboard-main/dashboard-main';
import { MembershipForm } from './dashboard/membership-form/membership-form';
import { MyApplicationForm } from './dashboard/my-application-form/my-application-form';
import { authGuard } from './guards/auth-guard';
import { guestGuard } from './guards/guest-guard';

export const routes: Routes = [
  { path: '', component: LandingPageComponent, canActivate: [guestGuard] },
  { path: 'register', component: RegisterFlowComponent, canActivate: [guestGuard] },
  { path: 'login', component: StatusCheckFlowComponent },
  {
    path: 'dashboard',
    component: DashboardMain,
    canActivate: [authGuard],
    children: [
      { path: 'membership-form', component: MembershipForm },
      { path: 'my-application-form', component: MyApplicationForm },
      { path: '', redirectTo: 'membership-form', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '' },
];
